import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
  processor,
  withCampaignSiteMap,
  withAccountsSiteMap,
} from '@bingads-webui-react/with-site-map';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { SmartLastURL } from './smart-last-url';

const LastCampaignURL = withCampaignSiteMap(SmartLastURL, [processor.processPath]);
const LastAccountsURL = withAccountsSiteMap(SmartLastURL, [processor.processPath]);

export const withLastURL = (WrappedComponent) => {
  class LastUrl extends React.PureComponent {
    renderWrappedComponent = (buttonText, lastUrl, lastPath) => {
      const {
        backButtonUrl,
        backButtonText,
        i18n,
        ...others
      } = this.props;

      return (
        <WrappedComponent
          backButtonUrl={lastUrl}
          backButtonPath={lastPath}
          backButtonText={i18n.getString(_TL_(buttonText))}
          i18n={i18n}
          {...others}
        />
      );
    }

    render() {
      const {
        scope,
        serverContext,
      } = this.props;

      if (_.has(scope.values, 'aid')) {
        return (
          <LastCampaignURL scope={scope} render={lastUrlState => this.renderWrappedComponent('Back to campaigns', lastUrlState.lastUrl, lastUrlState.lastPath)} serverContext={serverContext} />
        );
      }

      return (
        <LastAccountsURL scope={scope} render={lastUrlState => this.renderWrappedComponent('Back to accounts', lastUrlState.lastUrl, lastUrlState.lastPath)} serverContext={serverContext} />
      );
    }
  }

  LastUrl.propTypes = {
    backButtonUrl: PropTypes.string,
    backButtonText: PropTypes.string,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
    i18n: PropTypes.shape({}).isRequired,
    serverContext: PropTypes.shape({
    }),
  };

  LastUrl.defaultProps = {
    backButtonUrl: '',
    backButtonText: '',
    serverContext: {},
  };

  return withI18nConsumer(withScope(LastUrl));
};
